module.exports = __webpack_public_path__ + "img/electrician_thumbnail-600x450.d3497f39.jpg";